import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProductsPromptModalState } from './types';

const INITIAL_STATE: ProductsPromptModalState = {
  visible: false,
};

const productsPromptModalSlice = createSlice({
  name: 'productsPromptModal',
  initialState: INITIAL_STATE,
  reducers: {
    setProductsPromptModalState: (state, { payload }: PayloadAction<Omit<ProductsPromptModalState, 'visible'> | null>) => {
      const dismissButtonLabel = payload ? payload.dismissButtonLabel || 'Dismiss' : state.dismissButtonLabel;
      return {
        ...(payload || state),
        dismissButtonLabel,
        visible: !!payload,
      };
    },
  },
});

export default productsPromptModalSlice;
